module.exports = __webpack_public_path__ + "img/Metis.17275307.png";